import gs1Instance from '../api-index'
import qs from "query-string";

const { post, get } = gs1Instance;

const generateSSCC = async (payload) => {
    const response = await post("/api/sscc", payload);
    return response.data;
};

const generateSGTINS = async (payload) => {
	const response = await post("/api/sgtin", payload);
	return response.data;
};

const getSSCCData = async (params) => {
    const url = qs.stringifyUrl(
		{
			url: `/gs1/standard/label/sscc/table`,
			query: {
				...params,
			},
		},
		{ strict: true },
	);
	const response = await get(url);
	return response.data;
};

const getSGTINSData = async (params) => {
    const url = qs.stringifyUrl(
		{
			url: `/gs1/standard/label/sgtin/table`,
			query: params,
		},
		{ strict: true },
	);
	const response = await get(url);
	return response.data;
};


const downloadSgtinLabels = async (clientId, traceId) => {
  const response = await get(
    `/gs1/standard/label/sgtin/${clientId}/${traceId}`
  );
  return response.data;
};


export { generateSSCC, generateSGTINS, getSGTINSData, getSSCCData, downloadSgtinLabels };
